import React, { useState, useEffect } from "react";
import {
  Tab,
  Button,
  Icon,
  Table,
  Divider,
  Segment,
  Header,
  SegmentGroup,
  Grid,
  GridColumn
} from "semantic-ui-react";
import { LoadingSpinner } from "../../../components/Shared";
import { SiteForm, ListSites } from "../../../components/Admin/Sites";
import "./Sites.scss";
import { useAuth } from "../../../hooks";
import {
  isAdmin,
  hasPermission,
  isMaster,
} from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../Error";
import { Company, Permission } from "../../../api";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../contexts";

const permissionController = new Permission();
const companyController = new Company();

export function Sites() {
  const [reload, setReload] = useState(false);
  const [companySelected, setCompanySelected] = useState(null);

  const {
    accessToken,
    user: { role, company },
  } = useAuth();

  const [permissionsByRole, setPermissionsByRole] = useState([]);
  const [companiesFilter, setCompaniesFilter] = useState(null);

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const onReload = () => setReload((prev) => !prev);

  // 🔹 Cargar permisos
  useEffect(() => {
    (async () => {
      try {
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, []);

  // 🔹 Cargar empresas si no tiene
  useEffect(() => {
    (async () => {
      try {
        if (!company) {
          const response = await companyController.getCompanies(accessToken);
          setCompaniesFilter(response);
        } else {
          setCompanySelected(company);
        }
      } catch (error) {
        console.error(error);
        setCompaniesFilter([]);
      }
    })();
  }, []);

  const handleBack = () => {
    setCompanySelected(null);
    setReload(false);
  };

  // 🔹 Pestañas activos / inactivos (top level, como Users)
  const panes = [
    {
      menuItem: t("active_sites"),
      render: () => (
        <Tab.Pane attached={false}>
          {isMaster(role) && !company ? (
            companiesFilter === null ? (
              <LoadingSpinner />
            ) : (
              <Tab
                menu={{ fluid: true, vertical: true }}
                menuPosition="left"
                panes={companiesFilter.map((comp) => ({
                  menuItem: comp.name,
                  render: () => (
                    <Tab.Pane attached={false}>
                      <ListSites
                        sitesActive={true}
                        reload={reload}
                        onReload={onReload}
                        companySelected={comp._id}
                        role={role}
                      />
                    </Tab.Pane>
                  ),
                }))}
              />
            )
          ) : (
            <ListSites
              sitesActive={true}
              reload={reload}
              onReload={onReload}
              companySelected={companySelected}
              role={role}
            />
          )}
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_sites"),
      render: () => (
        <Tab.Pane attached={false}>
          {isMaster(role) && !company ? (
            companiesFilter === null ? (
              <LoadingSpinner />
            ) : (
              <Tab
                menu={{ fluid: true, vertical: true }}
                menuPosition="left"
                panes={companiesFilter.map((comp) => ({
                  menuItem: comp.name,
                  render: () => (
                    <Tab.Pane attached={false}>
                      <ListSites
                        sitesActive={false}
                        reload={reload}
                        onReload={onReload}
                        companySelected={comp._id}
                        role={role}
                      />
                    </Tab.Pane>
                  ),
                }))}
              />
            )
          ) : (
            <ListSites
              sitesActive={false}
              reload={reload}
              onReload={onReload}
              companySelected={companySelected}
              role={role}
            />
          )}
        </Tab.Pane>
      ),
    },
  ];

  if (
    isMaster(role) ||
    (isAdmin(role) && company) ||
    hasPermission(permissionsByRole, role._id, "sites", "view")
  ) {
    return (
      <>
        <div className="sites-page">
          <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
        </div>
      </>
    );
  }

  return <ErrorAccessDenied />;
}






function SelectedListCompanies(props) {
  const { companiesFilter, role, permissionByRole, handleSelected, t } = props;

  return (
    <div>
      {/* { isMaster(role) || isAdmin(role) ||
      hasPermission(permissionByRole, role._id, "sites", "view") ? ( */}
      <div>
        <div>
          {/* <SearchStandardSite
              dataOrigin={sites}
              data={sitesFilter}
              setData={setSitesFilter}
            /> */}
        </div>
        <Divider clearing />

        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t("company_name")}</Table.HeaderCell>
              <Table.HeaderCell>{t("email")}</Table.HeaderCell>
              <Table.HeaderCell>{t("actions")}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {companiesFilter.map((company) => (
              <Table.Row key={company._id}>
                <Table.Cell>{company.name ? company.name : ""}</Table.Cell>
                <Table.Cell>{company.email}</Table.Cell>
                <Table.Cell>
                  {
                    // isMaster(role) || isAdmin(role) ||
                    // hasPermission(permissionsByRole, role._id, "sites", "edit") ? (
                    <Button
                      icon
                      primary
                      onClick={() => {
                        handleSelected(company);
                      }}
                    >
                      <Icon name="angle double right" />
                    </Button>
                    // ) : null
                  }
                  {/* {isMaster(role) || isAdmin(role) ||
                    hasPermission(permissionsByRole, role._id, "sites", "edit") ? (
                      <Button
                        icon
                        color={site.active ? "orange" : "teal"}
                        onClick={openDesactivateActivateConfim}
                      >
                        <Icon name={site.active ? "ban" : "check"} />
                      </Button>
                    ) : null} */}
                  {/* {isMaster(role) || isAdmin(role) ||
                    hasPermission(permissionsByRole, role._id, "sites", "delete") ? (
                      <Button icon color="red" onClick={openDeleteConfirm}>
                        <Icon name="trash" />
                      </Button>
                    ) : null} */}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
      {/* ) : (
        // <ErrorAccessDenied />
        <></>
      )} */}
    </div>
  );
}
